module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department06-80eefe511345758cdc0375ae376b82bf.jpg";